export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    nuxtApp.hook('app:mounted', () => {
      const loadGtm = () => {
        const ID = import.meta.env.VITE_GTAG_ID;
        if (!ID) return;
        // Evento 'gtm.js' dello snippet standard di GTM ("Container caricato"):
        // senza di esso non scattano i trigger di visualizzazione pagina, tra cui
        // quello che attiva Google Analytics dentro il tag Google (GT-...).
        const w = window as any;
        w.dataLayer = w.dataLayer || [];
        w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        // GTM carica anche il banner Cookiebot (tag "Cookiebot CMP"): nessuna
        // dipendenza da jQuery, che nessun tag del container utilizza.
        const gtmScript = document.createElement('script');
        gtmScript.async = true;
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${ID}`;
        document.head.appendChild(gtmScript);
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => loadGtm());
      } else {
        setTimeout(loadGtm, 2000);
      }
    });
  }
});
